import { getAdminFranchisorById } from '@/api/franchisee';
import { FranchiseEdit } from '@/components/admin/edit/FranchiseEdit';
import { Franchise } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { Button, Flex, Form, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import dayjs from 'dayjs';

const EditDetailsPageFranchisor = (): React.JSX.Element => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm<Partial<Franchise>>();

  const { data: franchise } = useQuery<Franchise | null, Error>({
    queryKey: ['franchisor', id],
    queryFn: () => getAdminFranchisorById(id || ''),
  });
  useEffect(() => {
    if (!franchise) return;

    const valuesToSet: Partial<Franchise> = {
      ...franchise,
    };

    valuesToSet.established = franchise.established
      ? dayjs.utc(franchise.established)
      : undefined;

    valuesToSet.startedFranchising = franchise.startedFranchising
      ? dayjs.utc(franchise.startedFranchising)
      : undefined;

    form.setFieldsValue(valuesToSet);
  }, [form, franchise]);

  const onBack = () => {
    navigate(`/control-panel/franchisors/${id}`);
  };

  const onCancel = () => {
    navigate(`/control-panel/franchisors/${id}`);
  };

  return (
    <React.Fragment>
      <Flex justify={'start'} align={'start'} gap={8} vertical>
        <Button
          type={'link'}
          icon={<LeftOutlined />}
          onClick={onBack}
          style={{ color: '#22252D', fontWeight: 500, paddingLeft: 0 }}
        >
          Back
        </Button>
        <Typography.Title
          level={3}
          style={{
            margin: '0 0 24px',
          }}
        >
          Edit Franchise
        </Typography.Title>
      </Flex>
      <FranchiseEdit
        franchise={franchise as Franchise}
        form={form}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};

export default EditDetailsPageFranchisor;
